var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _path11, _path12, _path13, _path14, _path15, _rect3, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.683 61.764C176.549 69.8785 188.81 76.848 200.968 88.3225C213.126 99.797 225.191 115.758 221.234 128.011C217.229 140.216 197.21 148.709 181.435 153.256C165.612 157.798 154.037 158.333 144.074 158.723C134.113 159.066 125.713 159.261 108.523 165.167C91.3858 171.123 65.4493 182.898 53.6309 177.714C41.8126 172.53 44.0584 150.422 39.4676 128.36C34.8286 106.343 23.305 84.3253 26.576 65.7732C29.8981 47.2241 47.9668 32.0409 67.647 27.5479C87.3843 23.0098 108.67 29.1588 125.028 36.8195C141.386 44.4801 152.865 53.7156 164.683 61.764Z",
    fill: "#D0DFE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.999 60.0671C198.999 53.9561 195.412 49 190.992 49C186.572 49 183 53.9561 183 60.0671C183 63.2785 183.988 66.1781 185.567 68.1887C185.014 72.4664 183.59 78.4552 183.348 79.5277C183.348 79.5277 196.336 88.9998 196.336 80.3741C196.336 73.8292 196.771 69.6798 197.166 67.1376C198.395 65.0053 199.03 62.5564 198.999 60.0671Z",
    fill: "#FFE4C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 50,
    width: 13,
    height: 18,
    rx: 3.79,
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136 99.8775C138.819 98.8526 159.367 98.8526 176.085 109.501C177.093 105.405 180.92 76 180.92 76L198.043 77.137C198.043 77.137 201.87 115.226 194.216 134.883C190.59 142.666 148.879 126.487 148.879 126.487L136 99.8775Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.721 94.0176C170.256 92.3216 167.797 213.597 162.129 218.739C156.46 223.881 85.9203 224.711 81.2359 219.34C76.5514 213.969 65.7047 95.6986 117.721 94.0176Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.609 94.7877C121.231 93.3649 114.693 94.12 111 95.0885C113.276 101.815 124.081 183.934 125.113 223C128.891 222.937 134.452 222.804 139 222.534C138.711 192.691 136.728 126.878 126.609 94.7877Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121 106C126.114 131.546 131.229 189.691 132 216L121 106Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121 106C126.114 131.546 131.229 189.691 132 216",
    stroke: "#D8D8D8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126 100.242C126 102.622 111.896 102.622 111.896 100.021C111.896 97.4211 110 78.1305 110 78.1305L124.043 77C124.043 77 125.997 98.7302 126 100.242Z",
    fill: "#FFE0B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.82 80.8768C143.937 79.5237 144 78.1586 144 76.7511C144 58.1133 133.031 43 119.5 43C105.969 43 95 58.1012 95 76.7511C95.0003 78.8412 95.1409 80.9289 95.4209 83L143.82 80.8768Z",
    fill: "#3A4944"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.219 61.9314C135.325 60.7216 132.521 59.4197 130.241 57C124.274 63.9642 113.808 72.1382 110 74.7728C111.522 85.2129 117.347 93 124.303 93C132.42 93 139 82.4156 139 69.3562C139.003 66.8654 138.754 64.3815 138.259 61.9468L138.219 61.9314Z",
    fill: "#FFE4C1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 39.5,
    r: 6.5,
    fill: "#3A4944"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 72.5,
    r: 3.5,
    fill: "#FFE4C1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.892 136.819L138.368 148.186L121.647 193.131L91.1711 181.765L107.892 136.819Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.561 137.655L131.27 143.141L129.622 147.571L114.913 142.085L116.561 137.655Z",
    fill: "#FF6B3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.07 140.275L134.463 149.373L119.675 189.123L95.2816 180.025L110.07 140.275Z",
    fill: "#FDD28A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.206 165.02C123.258 164.81 127.602 161 131.684 161C136.569 161 140 164.063 140 167.894C140 175.979 133.619 178.329 131.2 178.329C127.14 178.329 126.456 177.711 125.7 177.182C124.47 177.478 122.661 179 117.838 179C113.016 179 119.206 165.02 119.206 165.02Z",
    fill: "#FFE4C1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.305 104.242C69.099 99.2473 61.3839 173.106 64.7641 179.493C68.1443 185.88 116.161 183.766 118.851 183.255C119.625 180.248 120.541 166.135 119.601 164.442C118.28 163.922 95.1231 163.636 95.1231 163.636C95.7235 161.23 103.25 130.732 103.505 127.25C104.687 110.906 102.196 107.045 90.305 104.242Z",
    fill: "#D8D8D8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 46,
    width: 17,
    height: 4,
    rx: 2,
    fill: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M189.129 66.5276C188.902 66.1338 189.037 65.6304 189.43 65.4029L193.18 63.2355C193.574 63.0076 194.078 63.1427 194.306 63.5372C194.533 63.931 194.398 64.4344 194.004 64.6619L190.255 66.8293C189.861 67.0572 189.356 66.9221 189.129 66.5276Z",
    fill: "#FF6B3F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189.125 59.0048C189.32 58.5931 189.811 58.4172 190.223 58.612L194.136 60.4651C194.547 60.6597 194.723 61.1505 194.529 61.5616C194.334 61.9733 193.843 62.1492 193.431 61.9544L189.518 60.1013C189.107 59.9067 188.931 59.416 189.125 59.0048Z",
    fill: "#FF6B3F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.256 66.829C183.821 66.9594 183.362 66.7116 183.232 66.2757L181.992 62.1196C181.862 61.6842 182.109 61.2259 182.545 61.0957C182.981 60.9654 183.439 61.2132 183.569 61.649L184.809 65.8051C184.939 66.2405 184.692 66.6989 184.256 66.829Z",
    fill: "#FF6B3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.165 66.2565C187.815 66.5481 187.295 66.5008 187.004 66.1509L184.232 62.8195C183.942 62.4702 183.989 61.9515 184.338 61.6604C184.687 61.3688 185.207 61.4161 185.498 61.766L188.27 65.0975C188.561 65.4467 188.514 65.9654 188.165 66.2565Z",
    fill: "#FF6B3F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M192.729 62.7539C192.698 63.2081 192.305 63.5512 191.851 63.5204L187.533 63.2272C187.079 63.1963 186.736 62.8033 186.766 62.3493C186.797 61.8951 187.19 61.552 187.644 61.5828L191.963 61.876C192.417 61.9069 192.76 62.2999 192.729 62.7539Z",
    fill: "#FF6B3F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113 101.082L119.328 104L121.545 101.75L123.828 104L127 100",
    fill: "#FFE0B8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113 101.082L119.328 104L121.545 101.75L123.828 104L127 100",
    stroke: "#D8D8D8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationCheck);
export default __webpack_public_path__ + "static/media/IllustrationCheck.1d8db34b99d5d7c81794d1f3292e8e28.svg";
export { ForwardRef as ReactComponent };